/* Landing de marca / fabricante — animaciones compartidas.
   Reveal al hacer scroll (.fbr-rv -> .is-in) + contador (data-count).
   Respeta prefers-reduced-motion. Idempotente (se puede cargar varias veces). */
(function () {
  if (window.__fbrInit) return;
  window.__fbrInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initReveal() {
    var items = document.querySelectorAll('.fbr-rv:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-count'));
    if (isNaN(target)) return;
    var suffix = el.getAttribute('data-suffix') || '';
    var prefix = el.getAttribute('data-prefix') || '';
    if (reduce) { el.textContent = prefix + target.toLocaleString('es-ES') + suffix; return; }
    var start = null, dur = 1400;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + Math.round(target * eased).toLocaleString('es-ES') + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initCounts() {
    var nums = document.querySelectorAll('[data-count]:not([data-done])');
    if (!('IntersectionObserver' in window)) { nums.forEach(function (el) { el.setAttribute('data-done', '1'); countUp(el); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.setAttribute('data-done', '1'); countUp(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    nums.forEach(function (el) { io.observe(el); });
  }

  /* ───────────────────────────────────────────────────────────────────────────
     MODAL DE CONSULTA
     El diálogo lo pone snippets/fabricante__consulta-dialog.liquid. Aquí solo se
     engancha: cualquier elemento con data-flu-consulta="info|presupuesto" lo abre.
     Si el diálogo NO está en la página, no se toca nada y el enlace navega como
     siempre: así una landing sin la sección de consulta sigue funcionando.
     ─────────────────────────────────────────────────────────────────────────── */
  var MOTIVOS = {
    info: {
      titulo: 'Pedir información',
      sub: 'Dinos qué necesitas y te respondemos con la referencia, el plazo y el precio.',
      etiqueta: 'Enviar consulta',
      msg: 'Cuéntanos tu aplicación'
    },
    presupuesto: {
      titulo: 'Solicitar presupuesto',
      sub: 'El precio depende del proyecto: pinza, software, formación y puesta en marcha. Cuéntanoslo y lo cotizamos.',
      etiqueta: 'Enviar solicitud',
      msg: 'Cuéntanos tu aplicación'
    },
    /* El experto NO va al buzón de contacto: abre un ticket en Freshdesk, con número
       de seguimiento y un agente asignado. Por eso pide la referencia. */
    experto: {
      titulo: 'Contactar con un experto',
      sub: 'Abrimos un ticket de soporte con tu consulta. Recibirás el número de seguimiento por correo.',
      etiqueta: 'Abrir ticket de soporte',
      msg: 'Cuéntanos qué necesitas resolver',
      ticket: true
    }
  };

  var TICKETS = 'https://tickets-web.fluitronic.workers.dev/ticket';
  var PORTAL = 'https://fluitronic-support.freshdesk.com/support/tickets/new';

  function initConsulta() {
    var dlg = document.getElementById('flu-fbr-consulta');
    if (!dlg || dlg.dataset.fluListo === '1') return;
    dlg.dataset.fluListo = '1';

    var q = function (sel) { return dlg.querySelector(sel); };
    var fab = (q('input[name="contact[Fabricante]"]') || {}).value || '';

    window.fluConsulta = {
      abrir: function (datos) {
        var m = MOTIVOS[(datos || {}).motivo] || MOTIVOS.info;

        var t = q('[data-flu-titulo]'); if (t) t.textContent = m.titulo;
        var s = q('[data-flu-sub]');    if (s) s.textContent = m.sub;
        var b = q('[data-flu-enviar]'); if (b) b.textContent = m.etiqueta;
        var l = q('[data-flu-lbl-msg]');if (l) l.textContent = m.msg;

        dlg.dataset.fluMotivo = (datos || {}).motivo || 'info';

        /* La referencia solo tiene sentido en el ticket; en los otros dos motivos
           sobra y alarga el formulario. */
        var extras = dlg.querySelectorAll('[data-flu-solo-experto]');
        for (var i = 0; i < extras.length; i++) extras[i].hidden = !m.ticket;

        var av = q('[data-flu-aviso]');
        if (av) { av.hidden = true; av.textContent = ''; av.className = 'fbr-dlg__aviso'; }

        var mo = q('[data-flu-motivo]'); if (mo) mo.value = m.titulo;
        /* El asunto del correo: sin esto todas las consultas llegan iguales y hay
           que abrir cada una para saber de qué marca es. */
        var bo = q('[data-flu-body]');
        if (bo) bo.value = m.titulo + (fab ? ' - ' + fab : '');

        if (typeof dlg.showModal === 'function') { dlg.showModal(); }
        else { dlg.setAttribute('open', ''); }

        var primero = q('select[required]') || q('input[name="contact[Nombre]"]');
        if (primero) primero.focus();
      },
      cerrar: function () { if (dlg.open) { dlg.close(); } }
    };

    /* ENVÍO DEL TICKET.
       Solo se intercepta cuando el motivo es «experto»: los otros dos siguen yendo al
       formulario de contacto de Shopify, que ya funciona. Si el Worker falla, el aviso
       da el enlace al portal en vez de dejar al visitante sin salida. */
    var form = dlg.querySelector('form');
    if (form) form.addEventListener('submit', function (e) {
      if (dlg.dataset.fluMotivo !== 'experto') return;
      e.preventDefault();

      var av = q('[data-flu-aviso]');
      var btn = q('[data-flu-enviar]');
      var val = function (n) { var el = dlg.querySelector('[name="contact[' + n + ']"]'); return el ? el.value : ''; };

      /* El texto SIEMPRE por textContent, nunca por innerHTML: parte de él viene del
         Worker y mañana podría traer el cuerpo del error de Freshdesk. El enlace al
         portal, cuando hace falta, se construye como nodo aparte. */
      var aviso = function (texto, clase, conEnlace) {
        if (!av) return;
        av.hidden = false;
        av.className = 'fbr-dlg__aviso fbr-dlg__aviso--' + clase;
        av.textContent = texto;
        if (!conEnlace) return;
        av.appendChild(document.createTextNode(' Puedes abrirlo a mano en '));
        var a = document.createElement('a');
        a.href = PORTAL;
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        a.textContent = 'el portal de soporte';
        av.appendChild(a);
        av.appendChild(document.createTextNode('.'));
      };

      if (btn) { btn.disabled = true; btn.textContent = 'Abriendo el ticket…'; }
      aviso('', 'espera');
      if (av) av.hidden = true;

      fetch(TICKETS, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({
          motivo: 'Contactar con un experto',
          nombre: val('Nombre'), email: val('email'), empresa: val('Empresa'),
          telefono: val('Telefono'), tipo: val('Tipo'), referencia: val('Referencia'),
          mensaje: val('Aplicacion'), fabricante: val('Fabricante'), pagina: val('Pagina'),
          nickname: val('nickname')
        })
      }).then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, d: d }; });
      }).then(function (res) {
        if (btn) { btn.disabled = false; btn.textContent = MOTIVOS.experto.etiqueta; }
        if (res.ok) {
          var num = res.d && res.d.ticket ? ' Tu número de seguimiento es el ' + res.d.ticket + '.' : '';
          aviso('Ticket abierto.' + num + ' Te escribimos al correo que nos has dado.', 'ok');
          if (form.reset) form.reset();
        } else {
          var msg = (res.d && res.d.error) || 'No hemos podido abrir el ticket.';
          aviso(msg, 'mal', true);
        }
      }).catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = MOTIVOS.experto.etiqueta; }
        aviso('No hemos podido conectar.', 'mal', true);
      });
    });

    var x = q('[data-flu-cerrar]');
    if (x) x.addEventListener('click', function () { window.fluConsulta.cerrar(); });

    /* Clic en el fondo cierra. Se compara contra el propio dialog porque el
       ::backdrop no es un elemento y no recibe eventos por su cuenta. */
    dlg.addEventListener('click', function (e) { if (e.target === dlg) window.fluConsulta.cerrar(); });

    /* Si el envío falló o salió bien, Shopify recarga con #contact_form: se reabre
       solo para que el usuario vea el resultado en vez de perderlo. */
    if (q('[data-flu-reabrir]')) window.fluConsulta.abrir({});
  }

  /* Delegado en document: cubre los botones que el editor de temas vuelve a pintar
     y los de secciones que se cargan después. */
  function initDisparadores() {
    if (document.documentElement.dataset.fluConsultaDeleg === '1') return;
    document.documentElement.dataset.fluConsultaDeleg = '1';
    document.addEventListener('click', function (e) {
      var el = e.target.closest ? e.target.closest('[data-flu-consulta]') : null;
      if (!el) return;
      if (!window.fluConsulta) return;   // sin diálogo en la página, el enlace navega
      e.preventDefault();
      window.fluConsulta.abrir({ motivo: el.getAttribute('data-flu-consulta') });
    });
  }

  ready(function () { initReveal(); initCounts(); initConsulta(); initDisparadores(); });

  // Soporte editor de temas: re-inicializar al recargar secciones
  document.addEventListener('shopify:section:load', function () {
    initReveal(); initCounts(); initConsulta(); initDisparadores();
  });
})();
